import supportList from '@/assets/temp/support.json'

//сюда нужно поставить запрос на получение весь список
const getSupportList = () => {
  return supportList
}

//сюда нужно поставить запрос на получение по id
const getSupportById = (supportId) => {
    return supportList.find(item => item.id == supportId)
}

 //Поиск
 const searchSort = (list, searchText)  => {
       
  const text = searchText.toUpperCase()
  const newList = []

  list.forEach(item => {

   if (item.childs) {

     item.childs.forEach(itemChild => {
       const question = itemChild.question.toUpperCase()
   
       if (question.indexOf(text) != -1) {
         newList.push(itemChild)
       }
     })
   } else {
     const question = item.question.toUpperCase()
    
     if (question.indexOf(text) != -1) {
       newList.push(item)
     }
   }
  })

  return newList
}

export default {
  getSupportList,
  getSupportById,
  searchSort
}